import { Tooltip, TooltipProps } from "@mui/material";
import { ReactNode } from "react";
import { createUseStyles } from "react-jss";

type Props = {
  children: ReactNode;
  /**
   * Allow to display nested tooltip BUT breaks tooltip "placement" prop
   */
  hasNestedTooltips?: boolean;
} & TooltipProps;

/**
 * Features added to the MUI Tooltip:
 * - Renders a tooltip around children only if a title is provided.
 * - Title is displayed on multiple lines if it's a string (\n character breaks line)
 * - Supports all MUI Tooltip props including 'interactive'
 */
function JTooltip({
  children,
  hasNestedTooltips = true,
  ...tooltipProps
}: Props) {
  const classes = useStyles();
  const { title } = tooltipProps;
  return title ? (
    <Tooltip
      {...tooltipProps}
      title={
        typeof title === "string" ? (
          <span className={classes.multiline}>{title}</span>
        ) : (
          title
        )
      }
    >
      {/* Wrapping in a span allow nested children with nested tooltips */}
      {hasNestedTooltips ? <span>{children}</span> : children}
    </Tooltip>
  ) : (
    children
  );
}

export default JTooltip;

const useStyles = createUseStyles({
  multiline: {
    whiteSpace: "pre-line",
  },
});
